import script from "./TOTPLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TOTPLogin.vue?vue&type=script&setup=true&lang=js"

import "./TOTPLogin.vue?vue&type=style&index=0&id=30940e1a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30940e1a"]])

export default __exports__